import { render, staticRenderFns } from "./TambahUnit.vue?vue&type=template&id=3b7757e6&scoped=true"
import script from "./TambahUnit.vue?vue&type=script&lang=js"
export * from "./TambahUnit.vue?vue&type=script&lang=js"
import style0 from "./TambahUnit.vue?vue&type=style&index=0&id=3b7757e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7757e6",
  null
  
)

export default component.exports